const CACHE_KEY = 'global_scope_territories_cache';
const TTL_MS = 60 * 60 * 1000; // 1 hour
export function readTerritoriesCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw)
            return null;
        const { territories, cachedAt } = JSON.parse(raw);
        if (Date.now() - cachedAt > TTL_MS)
            return null;
        return territories;
    }
    catch (_a) {
        return null;
    }
}
export function writeTerritoriesCache(territories) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ territories, cachedAt: Date.now() }));
    }
    catch (_a) {
        // localStorage unavailable — silently skip
    }
}
